import { TableStyleProps } from '.'
import { borderRadius, color, system, verticalAlign } from 'styled-system'
import styled from 'styled-components'

type BorderCollapse = 'collapse' | 'separate'

export interface CustomCSSProps {
  borderSpacing?: string | number
  borderCollapse?: BorderCollapse
}

const borderSpacing = system({
  borderSpacing: {
    property: 'borderSpacing'
  }
})

const borderCollapse = system({
  borderCollapse: {
    property: 'borderCollapse'
  }
})

export const TableBase = styled.table<TableStyleProps>`
  width: 100%;
  vertical-align: middle;
  border-spacing: 0;
  border-collapse: collapse;
  border-radius: 8px 8px 0 0;
  background-color: ${({ theme }) => theme.colors.primary.white};
  -webkit-font-smoothing: antialiased;
  ${borderSpacing}
  ${borderCollapse}
    ${verticalAlign}
    ${borderRadius}
    ${color}
`
